export enum hyperMonitoringTypes {
	BENEFICIARIES = 'beneficiariesRequests',
}

export const HYPER_MONITORING_TYPES = [hyperMonitoringTypes.BENEFICIARIES];

const BANK_DETAILS_LABEL_PREFIX = 'page.customerAccounts.forms.beneficiaries.bankDetails.';

/** Corridor-specific beneficiary bank fields — only included in the modal when populated. */
export const HYPER_MONITORING_BANK_SCHEMA_FIELDS: Array<{ beneficiaryKey: string; labelKey: string }> = [
	{ beneficiaryKey: 'accountNumber', labelKey: `${BANK_DETAILS_LABEL_PREFIX}accountNumber` },
	{ beneficiaryKey: 'iban', labelKey: `${BANK_DETAILS_LABEL_PREFIX}iban` },
	{ beneficiaryKey: 'bicSwift', labelKey: `${BANK_DETAILS_LABEL_PREFIX}bic_swift` },
	{ beneficiaryKey: 'aba', labelKey: `${BANK_DETAILS_LABEL_PREFIX}aba` },
	{ beneficiaryKey: 'bankCode', labelKey: `${BANK_DETAILS_LABEL_PREFIX}bankCode` },
	{ beneficiaryKey: 'sortCode', labelKey: `${BANK_DETAILS_LABEL_PREFIX}sortCode` },
	{ beneficiaryKey: 'bsbCode', labelKey: `${BANK_DETAILS_LABEL_PREFIX}bsbCode` },
	{ beneficiaryKey: 'branchCode', labelKey: `${BANK_DETAILS_LABEL_PREFIX}branchCode` },
	{ beneficiaryKey: 'clabe', labelKey: `${BANK_DETAILS_LABEL_PREFIX}clabe` },
	{ beneficiaryKey: 'cnaps', labelKey: `${BANK_DETAILS_LABEL_PREFIX}cnaps` },
	{ beneficiaryKey: 'ifsc', labelKey: `${BANK_DETAILS_LABEL_PREFIX}ifsc` },
	{ beneficiaryKey: 'postcode', labelKey: `${BANK_DETAILS_LABEL_PREFIX}postcode` },
	{ beneficiaryKey: 'stateOrProvince', labelKey: `${BANK_DETAILS_LABEL_PREFIX}stateOrProvince` },
];
